import React from 'react';
import { connect } from 'react-redux';

import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../app/state/AppState';
import { MapStateToProps } from '../../../app/utils/ConnectUtils';
import { NavLocationAreas } from '../layout/NavLocation';
import { Breadcrumbs } from './Breadcrumbs';

const mapStateToProps: MapStateToProps<Breadcrumbs.StateProps> = (state: AppState) => ({
  items: state.breadcrumbs,
  linkLastItem: !CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) && NavLocationSelectors.selectNavLocation(state) === NavLocationAreas.SiteAdmin.site_users,
});

export const ConnectedBreadcrumbs: React.ComponentClass<{}> =
  connect(mapStateToProps, null)(Breadcrumbs);
